import React from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import GameInfo from "./pages/GameInfo";
import Team from "./pages/Team";
import Contact from "./pages/Contact";
import TermsOfUse from "./pages/Terms"
import PrivacyPolicy from "./pages/Privacy"

// import RollingDice from "./components/RollingDice";

const App = () => {
  return (
    <BrowserRouter>
      {/* <RollingDice /> Include animation globally */}
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gameinfo" element={<GameInfo />} />
        <Route path="/team" element={<Team />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/Privacy" element={<PrivacyPolicy />} />
        <Route path="/Terms" element={<TermsOfUse />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
